// extracted by mini-css-extract-plugin
export default {"blacklistOverview":"BlacklistOverview_blacklistOverview__W662O","subtitle":"BlacklistOverview_subtitle__--CMj"};